export function focusableChildren(node: HTMLElement) {
  const nodes = Array.from(
    node.querySelectorAll(
      'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])',
    ),
  ) as HTMLElement[];

  const index = nodes.indexOf(document.activeElement as HTMLElement);

  const update = (d: number) => {
    let i = index + d;
    i += nodes.length;
    i %= nodes.length;

    nodes[i].focus();
  };

  return {
    next: (selector: string, dry = false) => {
      const reordered = [...nodes.slice(index + 1), ...nodes.slice(0, index + 1)];

      for (let i = 0; i < reordered.length; i += 1) {
        if (!selector || reordered[i].matches(selector)) {
          if (!dry) {
            reordered[i].focus();
          }
          return reordered[i];
        }
      }
    },
    prev: (selector: string, dry = false) => {
      const reordered = [...nodes.slice(index + 1), ...nodes.slice(0, index + 1)];

      for (let i = reordered.length - 2; i >= 0; i -= 1) {
        if (!selector || reordered[i].matches(selector)) {
          if (!dry) {
            reordered[i].focus();
          }
          return reordered[i];
        }
      }
    },
    update,
  };
}
